<template>
  <div class="welcome-container">
    <div class="welcome-head">
      <div class="head-container">
        <img src="../../../static/logo2.png"/>
        <div class="segmentation">|</div>
        <div class="tag">分销货源市场</div>
      </div>
    </div>
    <div class="welcome-body">
      <div class="body-container">
        <div class="body-left">
          <div class="tag1">分销供应 一步到位</div>
          <div class="tag2">自营/1688选品分销</div>
          <div class="tag3">
            <div class="tag3-left">
              <ul>
                <li>一键授权号</li>
                <li>提交入驻</li>
              </ul>

            </div>
            <div class="tag3-right">
              <ul>
                <li>联 系 人：林先生</li>
                <li>招商热线：<span>172 6848 4904</span></li>
              </ul>
            </div>
          </div>
        </div>
        <div class="body-right">
          <div v-if="loginCheck" class="welcome">
            <div class="welcome-login-ckeck-success">
              <div class="welcome-label">选择身份类型</div>
              <div class="select-identity">
                <div class="identity-sales" @click="selectIdentity(1)" :class="{active:type==1}">
                  成为分销商
                </div>
                <div class="identity-supplier" @click="selectIdentity(2)" :class="{active:type==2}">
                  成为供应商
                </div>
              </div>
              <div style="margin-top: 20px;">
                <el-button style=" width: 100%; " type="primary" @click="goto">确定</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import {Loading, Message} from "element-ui";
import router, {resetRouter} from "../../router";

export default {
  data() {
    return {
      token: null,
      loginCheck: false,
      isCheck: false,
      type: 1,
      shop_id: null,
      is_choose_identity: 1,
      loadingInstance:null,
    }
  },
  mounted() {
    if (this.$route.query.key) {
      this.token = this.$route.query.key
      this.passwordFreeLogin()
    } else if (this.$route.query.login_token) {
      this.token = this.$route.query.login_token
      this.passwordFreeLogin()
    } else {
      Message.error("参数错误")
    }
    if (this.$route.query.is_choose_identity) {
      this.is_choose_identity = this.$route.query.is_choose_identity
    }
  },
  methods: {
    selectIdentity(type) {
      this.type = type
    },
    goto() {
      let path = "/statistics"
      switch (this.type) {
        case 2:
          path = "/partnerJoin"
          break;
        case 1:
          path = "/supplierAdd"
          break;
      }
      //shop_id

      this.$router.push({
        path
      })
    },
    //passwordFreeLogin
    passwordFreeLogin() {
      this.isCheck = false;
      this.loginCheck = false;
      this.loadingInstance = Loading.service({
        text: "登录验证中..."
      });
      this.$get(this.$api.passwordFreeLogin + this.token).then((res) => {
        this.isCheck = true;
        if (res.status == 200) {
          localStorage.setItem('logintoken_shop', res.data.token.token)
          localStorage.setItem('userdata_shop', JSON.stringify(res.data.user))
          this.$store.commit('saveShopData', res.data.shop)
          this.getPermissionList();
        }
      }).finally(() => {
       // loadingInstance.close();
      })
    },
    // 获取权限列表
    getPermissionList(){
      this.$get(this.$api.permissionList).then(res => {
        if (res.status == 200) {
          localStorage.setItem('menuList', JSON.stringify(res.data))
          resetRouter()
          this.routerList=[]
          this.handlerRouters(res.data)
          this.routerList.forEach(item => {
            router.addRoute('index',item)
          })
          this.getRuleIds()

        }
      })
    },
    // 获取当前帐号的权限ids
    getRuleIds(){
      this.$get(this.$api.ruleIds).then(res => {
        if (res.status == 200) {
          localStorage.setItem('ruleIds', JSON.stringify(Object.values(res.data)))
          if (this.is_choose_identity != 1) {
            this.$router.push({
              path: "/statistics"
            })
          } else {
            this.loginCheck = true;
          }
        }
      }).finally(()=>{
        if(this.loadingInstance){
          this.loadingInstance.close()
        }
      })
    },
    // 处理路由集合
    handlerRouters(list){
      list.forEach(item => {
        if(item.component&&item.path){
          this.routerList.push({path:item.path,name:item.title,'component':() => import(`@/views${item.component}`),meta:{requireAuth: true}})
        }
        if(item.child.length>0){
          this.handlerRouters(item.child)
        }
      })
    },
  }
}
</script>
<style scoped>
body {
  overflow: hidden;
}

.welcome-container {
  width: 100vw;
  height: 100vh;
  position: relative;
}

.welcome {
  margin-top: 15px;
  height: 300px;
  width: 450px;
  box-sizing: border-box;
  box-shadow: 0px 0px 10px #c0c4cc;
  padding: 40px;
  background: #FFFFFF;
  border-radius: 5px;
}


.select-identity {
  display: flex;
}

.identity-sales, .identity-supplier {
  box-sizing: border-box;
  width: 48%;

  border: 1px solid #ccc;
  text-align: center;
  position: relative;
  height: 100px;
  line-height: 100px;
  cursor: pointer;
}

.welcome-label {
  line-height: 24px;
  font-size: 16px;
  margin-bottom: 30px;
}

.select-identity .active {
  background: rgba(58, 142, 230, 0.1);
  border: #3a8ee6 1px solid;
}

/* 三角形 */
.select-identity .active::after {
  content: "";
  position: absolute;
  bottom: 0px;
  right: 0px;
  border-bottom: 30px solid #3a8ee6;
  border-left: 30px solid transparent;
}

/* 三角形勾 */
.select-identity .active::before {
  content: '';
  position: absolute;
  width: 8px;
  height: 4px;
  background: transparent;
  bottom: 6px;
  right: 5px;
  border: 2px solid white;
  border-top: none;
  border-right: none;
  transform: rotate(-55deg);
  z-index: 9;
}

.identity-sales {
  margin-right: 4%;
}

.identity-supplier {

}

.welcome-head {
  height: 90px;
  position: relative;
}

.welcome-head .head-container {
  width: 1400px;

  margin-left: auto;
  margin-right: auto;
  display: flex;
  line-height: 90px;
}


.welcome-head .head-container .tag {
  color: #9d9d9d;
  font-size: 24px;
}

.welcome-head .head-container .segmentation {
  margin: 0 20px;
  color: #cdcdcd;
  font-size: 24px;
  position: relative;
  top: -3px;
}

.head-container img {
  margin-top: 25px;
  width: 142px;
  height: 41px;
}

.welcome-body {
  width: 100%;
  height: calc(100vh - 90px);
  background-size: cover;
  background-image: url("../../../static/authwelcome_bg.jpg");
}

.body-container {
  width: 1400px;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  justify-content: space-between;
  font-family: "Microsoft YaHei";
}

.body-container .body-left, .body-container .body-right {
  margin-top: 200px;
}

.body-container .body-left {
  width: 600px;
  padding-left: 20px;
}

.body-container .body-right {
  width: 500px;
}

.body-left .tag1 {
  font-size: 72px;

}

.body-left .tag2 {
  font-size: 42px;
  margin-top: 63px;
}

.body-left .tag3 {
  margin-top: 90px;
  display: flex;
  font-size: 20px;
}

.body-left .tag3 ul {
  margin: 0;
}

.body-left .tag3 ul li {
  line-height: 40px;
}

.body-left .tag3-left, .body-left .tag3-right {

}

.body-left .tag3-left {
  width: 200px;
  border-right: 2px solid #c0c4cc;
}

.body-left .tag3-right {
  padding-left: 20px;
  width: 400px;
}

.body-left .tag3-right ul {
  list-style-type: none;
}

.body-left .tag3-right li span {
  font-size: 30px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/views/authWelcome/index.vue